module.exports = __webpack_public_path__ + "img/activity61.9f2e1f44.png";